import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-arrow-icon',
  templateUrl: './arrow-icon.component.html',
  styleUrls: ['./arrow-icon.component.scss']
})
export class ArrowIconComponent implements OnInit {
  @Input() flipVertical = false
  @Input() active = false
  @Input() mainColor = '#fff'

  constructor() { }

  ngOnInit(): void {
  }

}
